import React from 'react';

class VMovTable extends React.Component {

    data(dt) {

        let vec = dt.split("-");
        let dia = vec[2];
        let mes = vec[1];
        let ano = vec[0];

        return dia + " / " + mes + " / " + ano;

    }

    ghg(g) {
        if (g) return "Sim";
        else return "Não";
    }

    render() {
        return(
            <div>
                <br /><br />
                <p Style={ "font-family: 'Arial'; font-size: 16px; color: #666666; float: left; margin-right: 20px;" }>
                    <b>Legenda:</b>
                </p>
                <table Style={ "margin-top: -5px; border-collapse: collapse; width: 200px; font-family: 'Arial'; font-size: 16px; color: #666666;" }>
                    <tbody>
                        <tr Style={ "height: 25px;" }>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px;" }>
                                Correto
                            </td>
                            <td Style={ "border: 1px solid #666666; padding-left: 10px; background: #ddeeff;" }>
                                Editado
                            </td>
                        </tr>
                    </tbody>
                </table><br /><br />
                <table id="visualizar-movimentacao-table">
                    <tbody>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errGhg }>
                                <b>GHG:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errGhg }>
                                <span>{ this.ghg(this.props.ghg) }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errData }>
                                <b>Data:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errData }>
                                <span>{ this.data(this.props.data) }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errBanco }>
                                <b>Banco:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errBanco }>
                                <span>{ this.props.bancoNome }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <b>Conta:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <span>{ this.props.conta }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <b>Código da Conta:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <span>{ this.props.codConta }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <b>Código da Movimentação:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errContaId }>
                                <span>{ this.props.codMovimentacao }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errHistorico }>
                                <b>Histórico:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errHistorico }>
                                <span>{ this.props.historico }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errDescricao }>
                                <b>Descrição da Movimentação:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errDescricao }>
                                <span>{ this.props.descricao }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errValor }>
                                <b>Valor:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errValor }>
                                <span>{ "R$ " + this.props.valor }</span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errNotaFiscal }>
                                <b>Documento Fiscal:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errNotaFiscal }>
                                <span>
                                    <p className={ "vismov-download-nf" }
                                        onClick={ this.props.downloadNotaFiscal }>
                                        { this.props.notaFiscal }
                                    </p>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errComprovante }>
                                <b>Comprovante de Pagamento:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errComprovante }>
                                <span>
                                    <p className={ "vismov-download-nf" }
                                        onClick={ this.props.downloadComprovante }>
                                        { this.props.comprovante }
                                    </p>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td className={ "vismov-td-corr-" + this.props.errAnaliseContabil }>
                                <b>Análise Contábil:</b>
                            </td>
                            <td className={ "vismov-td-corr-" + this.props.errAnaliseContabil }>
                                <span>{ this.props.analiseContabil }</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

}

export default VMovTable;

